<template>
    <span class="fill_need" :class="{'filled':cell_data.filled}">
        {{ cell_data.fill_level }}
    </span>
</template>

<script>
    export default {
        name: "FilledJobCell",

        components: {},

        props: {
            cell_data: {
                type: Object,
                default: () => {}
            }
        },

        data() {
            return {};
        },

        mounted() {

        },

        methods: {}
    }
</script>
